import { Dispatch } from "react"
import { getDataExplorerCollection } from "../../../services/GetDataExplorer"

export function initData(queryoptions: any, dispatch: Dispatch<any>) {
    getDataExplorerCollection(queryoptions).then((collection) => {
        dispatch({type: 'SET_DATA', value: collection});
        dispatch({type: 'SET_LOADING_DATA', value: {loadingState: false}})
    })
}